import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { ActivitiesSearchBar, CustomMetaTitle } from 'Components';
import { Title } from './Title';
import { UserUpdates } from './UserUpdates';
import { Box, Grid, Stack } from '@mui/material';
import { UserPaychecks } from './UserPaychecks';
import { UserRights } from './UserRights';
import { useCustomDialog } from 'Hooks/useCustomDialog';
import { CommonActions } from './CommonActions';
import { UserRecognitionStatus } from './UserRecognitionStatus';
import { Recommendations } from './Recommendations';

export const Home = () => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.Home].userUpdates;
  const { dialog, setShowDialog } = useCustomDialog();

  return (
    <Stack
      gap={'48px'}
      maxWidth={isDesktop ? 'min(calc(100% - 70px), 1212px)' : undefined}
    >
      <CustomMetaTitle title={dictionary.pageTitle} />
      <Title />
      <Box m={'-50px 0 -16px'}>
        <ActivitiesSearchBar
          placeholder={Dictionary[DICTIONARY.Home].searchInputPlaceholder}
          source='home'
        />
      </Box>
      <UserRecognitionStatus />
      {isDesktop ? (
        <>
          <Recommendations />
          <CommonActions />
        </>
      ) : (
        <>
          <CommonActions />
          <Recommendations />
        </>
      )}
      {/* <Grid item xs={12} md={8}>
        <Messages />
      </Grid> */}
      {/* currently not visible */}
      {/* <RemindYou setShowDialog={setShowDialog} /> */}
      <Grid container spacing={isDesktop ? '48px' : 0}>
        <Grid item xs={12} md={8}>
          <UserUpdates setShowDialog={setShowDialog} />
        </Grid>
        <Grid item xs={12} md={4}>
          <UserPaychecks />
        </Grid>
      </Grid>
      <UserRights />
      {dialog}
    </Stack>
  );
};
